/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_EmailInputs */



/**
* | output |
* | --- |
* | "Email" |
*
* @param {Common_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_email = /** @type {((inputs?: Common_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("E-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email")
	return /** @type {LocalizedString} */ ("Email")
});